import React from 'react';

/** Challenges — a flag on a pole. Same stroke weight and active tan as the
 *  Ocean / IP Intel nav icons. */
export const ChallengesIcon = ({ active }: { active: boolean }) => {
  const c = active ? '#9A7A4C' : 'currentColor';
  return (
    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M5 21V4" stroke={c} strokeWidth="1.6" strokeLinecap="round" />
      <path d="M5 4.5c2.3-1.2 4.4-1.2 6.5 0s4.2 1.2 6.5 0v8.5c-2.3 1.2-4.4 1.2-6.5 0s-4.2-1.2-6.5 0"
        stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.5 7.6l1.4 1.4 2.8-2.8" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"
        opacity="0.75" />
    </svg>
  );
};
